import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { HookPatchPayload } from '@rossum/api-client/hooks';
import { api } from '../../../lib/apiClient';
import { throwError, throwInfo } from '../../../redux/modules/messages/actions';
import { credentialKeys } from '../../integration-credentials/core/hooks/queryKeys';
import { QUERY_KEY_HOOKS } from './useHooks';

type HookPatchMeta = { withMessage?: boolean };

type HookMutationVariables = {
  hookId: number;
  payload: HookPatchPayload;
  meta?: HookPatchMeta;
};

export const usePatchHook = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ hookId, payload }: HookMutationVariables) =>
      api.request(endpoints.hooks.patch(hookId, payload)),

    onSuccess: (data, { meta }) => {
      queryClient.invalidateQueries([QUERY_KEY_HOOKS, 'list']);
      queryClient.setQueryData([QUERY_KEY_HOOKS, 'detail', data.id], data);
      // The hook may have been (un)linked from credentials, whose `hooks` lists are now stale.
      queryClient.invalidateQueries({ queryKey: credentialKeys.all });

      if (meta?.withMessage) {
        dispatch(throwInfo('extensionUpdated'));
      }
    },

    onError: () => {
      dispatch(throwError('extensionUpdateFailed'));
    },
  });
};
